import "react-nice-dates/build/style.css"
import "./SelectDate.scss"

import { Modal } from "@deligoo/ui"
import { pl } from "date-fns/locale"
import dayjs from "dayjs"
import { memo, useCallback } from "react"
import { DatePickerCalendar } from "react-nice-dates"
import { useDispatch } from "react-redux"

import { useAppSelector } from "@/App"
import { setDate } from "@/store/global"

export const SelectDateModal = memo(({ handleClose }: { handleClose: () => void }) => {
  const dispatch = useDispatch()

  const date = useAppSelector((state) => state.global.date)

  const handleDateChange = useCallback(
    (newDate) => {
      dispatch(setDate(dayjs(newDate).format("YYYY-MM-DD")))
      handleClose()
    },
    [dispatch, handleClose]
  )

  return (
    <Modal className="date-modal" handleClose={handleClose} zIndex={1500} closeBtnPosition="inside">
      <Modal.Content>
        <DatePickerCalendar
          date={dayjs(date).toDate()}
          onDateChange={handleDateChange}
          maximumDate={dayjs().toDate()}
          locale={pl}
        />
      </Modal.Content>
    </Modal>
  )
})
